import { useAuth } from '@/shared/auth/AuthContext';
import { useCenterConfig } from '@/shared/hooks/useCenterConfig';
import { CuidadorMain } from './CuidadorMain';

export default function CuidadorDashboard() {
  const { user, accessCode, centerId, logout } = useAuth();
  const center = useCenterConfig(centerId);

  const userLabel = accessCode?.label || user?.email || '';
  const centerName = center?.name || centerId;

  return (
    <div className="min-h-full flex flex-col">
      <header className="bg-white border-b border-slate-100 px-4 md:px-6 h-14 flex items-center gap-3 shrink-0">
        <div className="w-9 h-9 rounded-xl bg-brand text-white grid place-items-center font-extrabold text-sm">GC</div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-bold text-slate-900 truncate">{centerName}</p>
          <p className="text-xs text-slate-500 truncate">{userLabel}</p>
        </div>
        <button onClick={logout} className="btn-ghost !py-1.5 !px-3 text-xs">Salir</button>
      </header>

      <main className="flex-1 p-3 md:p-4 min-h-0">
        <CuidadorMain centerId={centerId} />
      </main>
    </div>
  );
}
